import React, { memo, useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import RevenueManagementSearch from 'components/revenueMaganement/RevenueManagementSearch';
import RevenueManagementDialog from 'components/revenueMaganement/RevenueManagementDialog';
import RevenueManagementList from 'components/revenueMaganement/RevenueManagementList';
import DotsLoader from 'components/common/DotsLoader';

import './index.scss';

/**
 * Revenue management admin tool (partner contracts settings)
 * Allows to configure revenue goals and commissions for each region per year
 * @note used to live in nexplore CRM "expected values and guarantee/fixed sums"
 */
function RevenueManagement() {
  const [loading] = useState(false);
  const [dialog, setDialog] = useState(null);

  const closeDialog = useCallback(() => {
    setDialog(null);
  }, [setDialog]);

  const openDialogToCreate = useCallback(() => {
    setDialog({ data: null, isNew: true });
  }, [setDialog]);

  const openDialogToEdit = useCallback(
    (year, regionId) => {
      console.info(year, regionId);
      // get year and region id from data attribute, pass data from state to dialog
      setDialog({ data: null, isNew: false });
    },
    [setDialog],
  );

  return (
    <Box className="rev-mgmt__wrapper">
      {loading && <DotsLoader backdrop />}
      {dialog ? (
        <RevenueManagementDialog
          data={dialog.data ?? null}
          isNew={dialog.isNew ?? true}
          close={closeDialog}
        />
      ) : null}
      <Container maxWidth="md">
        <RevenueManagementSearch create={openDialogToCreate} />
      </Container>
      <Box>
        <RevenueManagementList onEditClick={openDialogToEdit} />
      </Box>
    </Box>
  );
}

export default memo(RevenueManagement);
